import React, { Component } from "react";
import { withTranslation } from "react-i18next";
class PreviewTermsConditions extends Component {
  state = {
    numPages: 0,
    width: 0,
  };

  componentDidMount() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.file && this.props.file !== prevProps.file) {
      this.setState({ numPages: 0, width: 0 });
      this.updateWidth();
    }

    if (this.state.width === 0 && prevState.width !== 0) {
      this.updateWidth();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    if (numPages !== this.state.numPages) {
      this.setState({
        numPages,
      });
    }
  };

  updateWidth = () => {
    const el = this.pdfContainerRef.current;
    if (!el) {
      return;
    }
    const w = el.offsetWidth;
    if (w > 0 && w !== this.state.width) {
      this.setState({ width: w });
    }
  };

  pdfContainerRef = React.createRef();

  render() {
    const { width } = this.state;
    const { file } = this.props;

    return (
      <div>
        <div style={this.props.cardStyle} className={this.props.className}>
          {/* THIS DIV IS ALWAYS INCLUDED IN THE RENDER OUTPUT */}
          <div
            id="pdfDocument"
            data-testid="pdfDocument"
            ref={this.pdfContainerRef}
          >
            {/* Conditionally render the Document/Pages OR the loading message *inside* the container */}
            {!file || width === 0 ? (
              <div>Loading PDF…</div>
            ) : (
              <iframe
                src={file + "#view=FitH&toolbar=0"}
                width={width}
                className={this.props.pdfStyling}
                style={{ border: "none", display: "block" }}
                height={width} // A4 aspect ratio, adjust as needed
              >
                <h4 id="docNotFound">
                  {this.props.t("AcceptTermsConditions.docNotFound")}
                </h4>
              </iframe>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(PreviewTermsConditions);
